import React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import PropTypes from "prop-types";

export function MeasurementStartDateSelectBox({ setTargetPeriod }) {
  const handleChange = (event) => {
    let selectedPeriod = event.target.value;
    setTargetPeriod(selectedPeriod);
  };

  let periodAry = [];
  for (let i = 0; i >= -6; i--) {
    let dt = new Date();
    dt.setMonth(dt.getMonth() + i);

    const name = `${dt.getFullYear().toString()}/${(
      dt.getMonth() + 1
    ).toString()}`;
    const year = dt.getFullYear().toString();
    const month = (dt.getMonth() + 1).toString();
    let parsedMonth = "";
    if (month.length == 1) {
      parsedMonth = "0" + month;
    } else {
      parsedMonth = month;
    }
    const val = year + parsedMonth;

    periodAry.push({ name, val });
  }

  let periodList = periodAry.map((period, i) => {
    return (
      <MenuItem value={period.val} key={i}>
        {period.name}
      </MenuItem>
    );
  });

  return (
    <>
<FormControl sx={{ m: 1, width: 160 }}>
        <InputLabel id="print-period-select-helper-label">測定年月</InputLabel>
        <Select
          labelId="print-period-select-helper-label"
          id="print-period-select-helper"
          label="測定年月（FROM）"
          onChange={handleChange}
          size="small"
        >
          {periodList}
        </Select>
      </FormControl>
    </>
  );
}

MeasurementStartDateSelectBox.propTypes = {
  setTargetPeriod: PropTypes.any,
};
